import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useAuthStore } from '@/stores/auth';
import * as api from './api';

function useActiveTenantId(): string {
  const tenantId = useAuthStore((s) => s.tenantUser?.tenantId);
  if (!tenantId) throw new Error('useActiveTenantId called without an active tenant');
  return tenantId;
}

export function useActivityInbox(opts: api.ActivityFetchOpts = {}) {
  const tenantId = useActiveTenantId();
  return useQuery({
    queryKey: ['activity-inbox', tenantId, opts] as const,
    queryFn: () => api.getActivityInbox(tenantId, opts),
    refetchInterval: 10_000,
  });
}

export function useMarkActivitySeen() {
  const tenantId = useActiveTenantId();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => api.setActivityLastSeen(tenantId),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['activity-inbox', tenantId] }),
  });
}
